import { FC } from 'react';
import { createZodFormResolver, Form, lt } from '@mews/framework';
import { SchemaFormFields } from '@mews-commander/form';
import { useCommanderSelector } from '@mews-commander/utils';
import { TextKey } from '@mews-commander/enums';
import { FormLayout } from '../../FormLayout';
import { OriginFormSchema, OriginFormValues } from './types';
import { getOriginFormInitialValues } from './selectors';
import { useUpdateOriginMutation } from './useUpdateOriginMutation';

interface OriginFormProps {
    reservationIds: string[];
    scope: string;
    onSuccess: () => void;
}

export const OriginForm: FC<OriginFormProps> = ({ reservationIds, scope, onSuccess }) => {
    const defaultValues = useCommanderSelector((state) =>
        getOriginFormInitialValues(state, { scope })
    ) as OriginFormValues;
    const mutation = useUpdateOriginMutation(reservationIds);

    const onSubmit = (values: OriginFormValues) => {
        mutation.mutate(values, { onSuccess });
    };

    return (
        <Form
            onSubmit={onSubmit}
            resolver={createZodFormResolver(OriginFormSchema)}
            values={defaultValues}
            dataTestForm="origin-form"
        >
            <FormLayout loading={mutation.isPending} vertical={false}>
                <SchemaFormFields
                    schema={OriginFormSchema}
                    formDefinition={{
                        fields: {
                            origin: {
                                label: lt(TextKey.Origin),
                                field: {
                                    type: 'enum',
                                    enumPrefix: 'CommanderOrigin',
                                    showEmptyValue: false,
                                },
                            },
                        },
                    }}
                />
            </FormLayout>
        </Form>
    );
};
